// action - state management
import { SET_CLIENT_ID } from "./actions";

const initialState = {
  clientId: "",
};

const appReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CLIENT_ID: {
      return {
        ...state,
        ...action.payload,
      };
    }
    default: {
      return { ...state };
    }
  }
};

export default appReducer;
